import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import styled from 'styled-components';
export const Checkbox = ({ radius = 'rounded', ref, ...props }) => (_jsx(Root, { ...props, "$radius": radius, ref: ref, children: _jsx(Indicator, { "$radius": radius }) }));
const Root = styled(RadixCheckbox.Root) `
  display: flex;
  width: 20px;
  height: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: ${({ $radius }) => ($radius === 'full' ? '50%' : '6px')};
  border: 1px solid var(--borderA-4);
  background: transparent;
  cursor: pointer;

  &:hover {
    border-color: var(--borderA-5);
  }

  &:disabled {
    border-color: var(--borderA-2);
    background: var(--borderA-2);
    pointer-events: none;
  }
`;
const Indicator = styled(RadixCheckbox.Indicator) `
  width: 14px;
  height: 14px;
  border-radius: ${({ $radius }) => ($radius === 'full' ? '50%' : '4px')};
  background: var(
    --checkbox-indicator-background,
    radial-gradient(
      239.85% 141.42% at 100% 100%,
      var(--primary-10) 0%,
      var(--primary-6) 100%
    )
  );

  flex-shrink: 0;
`;
//# sourceMappingURL=checkbox.js.map